import { Router } from '@angular/router';
import { AlertService } from './../service/alert.service';
import { RecuperarSenhaService } from './../service/recuperar-senha.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-solicitar-nova-senha',
  templateUrl: './solicitar-nova-senha.component.html',
  styleUrls: ['./solicitar-nova-senha.component.css']
})
export class SolicitarNovaSenhaComponent implements OnInit {

  form!: FormGroup
  disable = true

  constructor(
    private builder: FormBuilder,
    private senhaService: RecuperarSenhaService,
    private alertService: AlertService,
    private router: Router
  ) {
    this.form = this.builder.group({
      vc_login: new FormControl('', Validators.required)
    })
  }

  ngOnInit(): void {
  }

  resolved(captchaResponse: string) {
    this.disable = false
  }

  errored(captchaResponse: any) {
  }

  submit() {
    this.senhaService.solicitarSenha(this.form.value).subscribe((resp: any) => {
      this.alertService.success(resp.mensagem);
      this.router.navigate(['/'])
    },
      error => {
        var resposta = JSON.parse(error)
        this.alertService.error(resposta.mensagem[0])
      })
  }

}
